import React from 'react';

import { Icon, Button } from '..';


export const SubmitButton = ({ title, onClick, vendorClass, ...props }) => (
  <Button
    additions={ [ 'fit-content', 'primary-icon' ] }
    vendorClass={ vendorClass }
    onClick={ onClick }
    { ...props }
  >
    <Icon
      svg="CHECK"
      svgProps={{ width: '28', height: '28' }}
    />
    <p>{ title }</p>
  </Button>
);
